import { TPCH_SF1000, tpchCopy } from '@/data/hardcharger-launch';

// Source: src/components/ProductsSection.tsx. Values include intentional inline spacing.
const en = {
  "s1": "Our Products",
  "s2": "Enterprise-grade data solutions built for performance, scale, and cost efficiency",
  "s3": "Open source (Apache-2.0)",
  "s4": "Every feature included",
  "s5": "Built for DuckDB 2.0",
  "s6": "Hardcharger™ bull",
  "s7": "Our DuckDB 2.0 server, rebuilt from scratch as GizmoSQL’s successor. Clients connect over Chargewire, an open HTTP protocol that streams Apache Arrow, through drivers for Python, Go, Java and JavaScript or plain curl. Users, roles, grants, row policies, column masking, SSO, mTLS identity and an audit log are built in, the web UI is in the binary, and every feature is free under Apache-2.0.",
  "s8": "Built for speed",
  "s9": `1 TB derived from TPC-H in ${tpchCopy('en').hcSeconds} s on one machine`,
  "s10": "Chargewire on the wire",
  "s11": "SQL over plain HTTP, results as Arrow",
  "s12": "Security in the core",
  "s13": "Roles, row policies, SSO, mTLS",
  "s14": "Web UI built in",
  "s15": "Editor, schema browser, Excel upload",
  "s16": "Install Hardcharger",
  "s17": "Explore Hardcharger",
  "s18": "Run it on GizmoData Cloud",
  "s19": "hardcharger-server",
  "s20": "$ hardcharger-server --web-ui --database lakehouse.duckdb",
  "s22": "UI    http://localhost:31337/ui/",
  "s23": "Docs  docs.hardcharger.gizmodata.com",
  "s24": "Hardcharger is ready",
  "s25": "Using GizmoSQL? Hardcharger is its successor, and GizmoSQL 1.x is now in maintenance. ",
  "s26": `Derived from TPC-H, 1 TB, 22 queries (${TPCH_SF1000.hardchargerBuild}):`,
  "s27": "GizmoSQL pages",
  "s28": "Method and caveats"
};
const pt: typeof en = {
  "s1": "Nossos produtos",
  "s2": "Soluções de dados empresariais criadas para desempenho, escala e eficiência de custos",
  "s3": "Código aberto (Apache-2.0)",
  "s4": "Todos os recursos incluídos",
  "s5": "Feito para o DuckDB 2.0",
  "s6": "Touro do Hardcharger™",
  "s7": "Nosso servidor DuckDB 2.0, reconstruído do zero como sucessor do GizmoSQL. Os clientes se conectam via Chargewire, um protocolo HTTP aberto que transmite Apache Arrow, por meio de drivers para Python, Go, Java e JavaScript ou simplesmente com curl. Usuários, papéis, permissões, políticas de linha, mascaramento de colunas, SSO, identidade por mTLS e um log de auditoria vêm integrados, a interface web está no próprio binário e todos os recursos são gratuitos sob Apache-2.0.",
  "s8": "Feito para velocidade",
  "s9": `1 TB derivado do TPC-H em ${tpchCopy('pt-BR').hcSeconds} s em uma única máquina`,
  "s10": "Chargewire na comunicação",
  "s11": "SQL sobre HTTP simples, resultados em Arrow",
  "s12": "Segurança no núcleo",
  "s13": "Papéis, políticas de linha, SSO, mTLS",
  "s14": "Interface web integrada",
  "s15": "Editor, navegador de esquemas, upload de Excel",
  "s16": "Instalar o Hardcharger",
  "s17": "Conheça o Hardcharger",
  "s18": "Execute no GizmoData Cloud",
  "s19": "hardcharger-server",
  "s20": "$ hardcharger-server --web-ui --database lakehouse.duckdb",
  "s22": "UI    http://localhost:31337/ui/",
  "s23": "Docs  docs.hardcharger.gizmodata.com",
  "s24": "Hardcharger is ready",
  "s25": "Usa o GizmoSQL? O Hardcharger é o seu sucessor, e o GizmoSQL 1.x agora está em manutenção. ",
  "s26": `Derivado do TPC-H, 1 TB, 22 consultas (${TPCH_SF1000.hardchargerBuild}):`,
  "s27": "Páginas do GizmoSQL",
  "s28": "Método e ressalvas"
};
export default { en, 'pt-BR': pt };
